import { Component, inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogueAction } from '../confirmation-dialogue/confirmation-dialogue.component';
import { PatientCallingEnum } from 'src/app/enums/enums';

@Component({
  selector: 'app-visitor-status-dialogue',
  templateUrl: './visitor-status-dialogue.component.html',
  styleUrls: ['./visitor-status-dialogue.component.scss']
})
export class VisitorStatusDialogueComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  @Input() data: any;
  ConfirmationTitle!: string;
  ConfirmationMessage!: string | HTMLElement;
  ConfirmActionText!: string;
  Action!: ConfirmDialogueAction;
  PatientCallingStatus = Object.keys(PatientCallingEnum)
    .filter((key) => !isNaN(Number(key)))
    .map((key) => ({
      key: Number(key),
      value: PatientCallingEnum[Number(key)]
    }));

  SelectedStatus!: number;
  AdditionalNotes: string = '';

  constructor() {}

  ngOnInit(): void {
    this.ConfirmationTitle = this.data.confirmMeta.alertTitle;
    this.ConfirmationMessage = this.data.confirmMeta.alertMessage;
    this.Action = this.data.confirmMeta.alertAction;
  }

  OnSubmit() {
    this.activeModal.close({ status: this.SelectedStatus, note: this.AdditionalNotes });
  }
}
